import { createTheme } from '@mui/material/styles';

import standard from './standard';
import typography from './typography';

// Overrides that applies to all themes
declare module '@mui/material/styles' {
  interface Palette {
    opacity75: Palette['primary'];
    opacity25: Palette['primary'];
  }

  // allow configuration using `createTheme`
  interface PaletteOptions {
    opacity75?: PaletteOptions['primary'];
    opacity25?: PaletteOptions['primary'];
  }
}

// Update the Chip's color prop options
declare module '@mui/material/Chip' {
  interface ChipPropsColorOverrides {
    opacity75: true;
    opacity25: true;
  }
}

declare module '@mui/material/Alert' {
  interface AlertPropsColorOverrides {
    secondary: true;
  }
}

declare module '@mui/icons-material' {
  interface SvgIconPropsColorOverrides {
    opacity75: true;
    opacity25: true;
  }
}

declare module '@mui/material/Icon' {
  interface IconPropsColorOverrides {
    opacity75: true;
    opacity25: true;
  }
}

declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    opacity75: true;
    opacity25: true;
  }
}
const theme = createTheme({
  // Theme example, this theme is not being used
  palette: {
    primary: {
      main: '#4B882F',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#414042',
      contrastText: '#FFFFFF'
    },
    text: standard.text,
    background: standard.background
  },
  typography
});

export default theme;
